(function() {
  class SvgImage extends HTMLElement {
    // This component is used to adjust the width of the SVG stroke in templates
    // It's a web component so it will work inside Ionic dialogs

    static get observedAttributes() {
      return ['fill', 'src', 'stroke', 'stroke-width'];
    }

    constructor() {
      super();
      this.attachShadow({
        mode: 'open',
      });
      this.shadowRoot.innerHTML = "<style></style><div class='content'></div>";
      this._content = '';
    }
    set src(value) {
      this._src = value;
      if (this._src) {
        fetch(this._src + '?v=1')
          .then((r) => r.text())
          .then((c) => {
            this._content = c;
            this._setStyle();
            this._setContent();
          });
      }
    }
    get src() {
      return this._src;
    }
    set stroke(value) {
      if (this._stroke === value) return;
      this._stroke = value;
      this._setStyle();
    }
    get stroke() {
      return this._stroke;
    }

    set strokeWidth(value) {
      if (this._strokeWidth === value) return;
      this._strokeWidth = value;
      this._setStyle();
    }
    get strokeWidth() {
      return this._strokeWidth;
    }
    set fill(value) {
      if (this._fill === value) return;
      this._fill = value;
      this._setStyle();
    }
    get fill() {
      return this._fill;
    }

    set class(value) {
      this._easyInstall = value.indexOf('easy-install-checkbox') > -1;
    }

    /**
     * NOTE: easy-install is handled by this component because it makes it easisest to style in the confirm template popup
     * The data is passed via class, because Ionic strips most other attributes from HTML for security reasons
     * By default for these custom elements, easy-install HTML will not be added, so should still be fairly performant
     */
    _setContent() {
      const html = this._content;
      this.shadowRoot.querySelector('.content').innerHTML = html;
    }
    _setStyle() {
      const style = `
					:host {
						display: block;
						width: 100%;
						height: 100%;
            padding: 20px;
					}
					div.content {
						width: inherit;
						height: inherit;
						display: flex;
						flex-direction: column;
					}
					svg {
						width: inherit;
						height: inherit;
					}
					svg path {
						stroke: ${this._stroke || '#AAAAAA'} !important;
						stroke-width: ${this._strokeWidth || '1'} !important;
						fill: ${this._fill || '#FFFFFF'} !important;
						fill-opacity: 1;
						opacity: 1;
						vector-effect: non-scaling-stroke;

            stroke-dasharray: 10000;
            stroke-dashoffset: 10000;
            animation: dash 10s linear forwards;
					}
          @keyframes dash {
            to {
              stroke-dashoffset: 0;
            }
          }
				`;
      this.shadowRoot.querySelector('style').innerHTML = style;
    }
    _camelize(str) {
      const arr = str.split('-');
      const capital = arr.map((item, index) =>
        index
          ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
          : item,
      );
      return capital.join('');
    }

    attributeChangedCallback(name, oldValue, newValue) {
      this[this._camelize(name)] = newValue;
    }
  }

  window.customElements.define('svg-image', SvgImage);
})();
